import React from 'react'
// components
import RowCell from '../RowCell'
import AppetiteSelect from './components/AppetiteSelect'
// themes
import colors from 'themes/colors'
// icons
import AddCircle from '@mui/icons-material/AddCircle'
import RemoveCircle from '@mui/icons-material/RemoveCircle'
// views
import { ButtonsWrapper } from '../../views'
import { TopRow, TopRowsContainer, TopRowsWrapper, TopRowContainer } from './views'
// utils
import { v4 as uuid } from 'uuid'
// types
import { TMatrix } from '../../types'
import { RowCellValueChangeFn } from '../../index'

interface Props {
  matrix: TMatrix
  setData: React.Dispatch<React.SetStateAction<TMatrix>>
  disabled: boolean
  removeRow: () => void
  appetiteEnabled: boolean
  rightRowsLength: number
  onCellValueChange: RowCellValueChangeFn
}

const TopMatrixSection: React.FC<Props> = ({
  matrix,
  setData,
  disabled,
  removeRow,
  appetiteEnabled,
  rightRowsLength,
  onCellValueChange
}) => {
  const addRow = () => {
    setData((prev) => {
      const newRow = new Array(rightRowsLength + 1).fill(null).map((_) => ({ id: uuid(), value: null }))

      return {
        ...prev,
        topSection: [...prev.topSection, newRow],
        ...(appetiteEnabled && { appetites: [...prev.appetites, { id: uuid(), options: [] }] })
      }
    })
  }

  const onCellSelect = (rowIdx: number, cellId: string, cellIdx: number) => () => {
    if (!appetiteEnabled || !disabled || cellIdx === 0) {
      return
    }

    setData((prev) => {
      return {
        ...prev,
        topSection: prev.topSection.map((row, index) => {
          if (index === rowIdx) {
            return row.map((item) => {
              if (item.id === cellId) {
                return { ...item, selected: !item.selected }
              }

              return { ...item, selected: false }
            })
          }

          return row
        })
      }
    })
  }

  return (
    <TopRowsContainer appetiteEnabled={appetiteEnabled} multiplier={matrix.bLeftSection[0].length - 2}>
      <TopRowsWrapper>
        {matrix.topSection.map((row, rowIdx) => (
          <TopRowContainer key={rowIdx}>
            {appetiteEnabled && (
              <AppetiteSelect
                optionIdx={rowIdx}
                disabled={disabled}
                options={matrix.options}
                appetite={matrix.appetites?.[rowIdx]}
              />
            )}
            <TopRow>
              {row.map(({ id, value, selected }, idx) => (
                <RowCell
                  key={id}
                  cellId={id}
                  value={value}
                  disabled={disabled}
                  isSelected={selected}
                  isRowHeader={idx == 0}
                  selectRow={onCellSelect(rowIdx, id, idx)}
                  onCellValueChange={onCellValueChange(rowIdx, id)}
                  isSelectable={appetiteEnabled && !disabled && idx !== 0}
                />
              ))}
            </TopRow>
          </TopRowContainer>
        ))}

        {!disabled && (
          <ButtonsWrapper disabled={matrix.topSection.length === 1}>
            <RemoveCircle htmlColor={colors.blue500} onClick={removeRow} />
            <AddCircle htmlColor={colors.blue500} onClick={addRow} />
          </ButtonsWrapper>
        )}
      </TopRowsWrapper>
    </TopRowsContainer>
  )
}

export default TopMatrixSection
